import { render, staticRenderFns } from "./NewTagFullscreen.vue?vue&type=template&id=40be80b4&"
import script from "./NewTagFullscreen.vue?vue&type=script&lang=js&"
export * from "./NewTagFullscreen.vue?vue&type=script&lang=js&"
import style0 from "./NewTagFullscreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports